import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import NavbarComponent from "../NavbarComponent";
import PageTitle from "../../common/PageTitle";
import { LeftBox } from "../../common/BoxAbstraction";
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import LogTable from "./LogTable";
import { getCurrentWeekDates } from "../utils";
import LoadingView from "../../common/LoadingView";

const filterData = {
  portal: {
    "Client Dashboard": "https://www.client-dashboard.niroggyan.com",
    "Config Portal": "https://main.d140ir0dqambxc.amplifyapp.com",
  },
};

const ActivityLogs = () => {
  const [portal, setPortal] = useState(filterData.portal["Client Dashboard"]);
  const [selectedClientId, setSelectedClientId] = useState("NGCL0035");
  const [loader, setLoader] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [maxcalenderDate, SetMaxCalenderDate] = useState("");
  const [open, setOpen] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState("currentWeek");

  const handleClose = () => setOpen(false);

  const fetchActivityData = async ({ queryKey }) => {
    const [, startDate, endDate, selectedClientId, portal] = queryKey;
    const idToken = localStorage.getItem("idTokenBilling");

    const config = {
      method: "get",
      url: `https://at8ed64ird.execute-api.ap-south-1.amazonaws.com/production/activity/user/logs?clientId=${selectedClientId}&startDate=${startDate}&endDate=${endDate}&origin=${portal}`,
      headers: {
        "Content-Type": "application/json",
        authorization: idToken,
      },
    };

    const response = await axios(config);
    return response.data;
  };

  const { isPending, isError, data } = useQuery({
    queryKey: ["activityData", startDate, endDate, selectedClientId, portal],
    queryFn: fetchActivityData,
    enabled: !!startDate && !!endDate,
    staleTime: 1000 * 60 * 2,
  });

  useEffect(() => {
    setStartDate(new Date(getCurrentWeekDates().startDate).getTime());
    setEndDate(new Date(getCurrentWeekDates().endDate).getTime());
  }, []);

  const formatFromDate = (date) => {
    const dateInFormat = new Date(date);
    const requiredTime = `${dateInFormat.getFullYear()}-${
      dateInFormat.getMonth() >= 9
        ? dateInFormat.getMonth() + 1
        : `0${dateInFormat.getMonth() + 1}`
    }-${
      dateInFormat.getDate() >= 10
        ? dateInFormat.getDate()
        : `0${dateInFormat.getDate()}`
    } 00:00:00.000`;
    console.log(requiredTime);
    return new Date(requiredTime).getTime();
  };

  const formatToDate = (date) => {
    const dateInFormat = new Date(date);
    const requiredTime = `${dateInFormat.getFullYear()}-${
      dateInFormat.getMonth() >= 9
        ? dateInFormat.getMonth() + 1
        : `0${dateInFormat.getMonth() + 1}`
    }-${
      dateInFormat.getDate() >= 10
        ? dateInFormat.getDate()
        : `0${dateInFormat.getDate()}`
    } 23:59:59.999`;
    console.log(requiredTime);
    return new Date(requiredTime).getTime();
  };

  const getCurrentMonthStartEndDates = () => {
    let todaysDate = new Date();
    let startDate = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth(),
      1,
      0,
      0,
      0,
      0
    );

    return {
      startDate: formatFromDate(startDate),
      endDate: formatToDate(todaysDate),
    };
  };

  const getPreviousMonthStartEndDates = () => {
    let todaysDate = new Date();
    const startDate = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth() - 1,
      1,
      0,
      0,
      0,
      0
    );
    const endDate = new Date(
      todaysDate.getFullYear(),
      todaysDate.getMonth(),
      0,
      23,
      59,
      59,
      0
    );
    return {
      startDate: formatFromDate(startDate),
      endDate: formatToDate(endDate),
    };
  };

  const setMaxDateCalender = (date) => {
    const dateFormat = new Date(date);
    const maxDate = new Date(dateFormat.setDate(dateFormat.getDate() + 31));
    const month =
      maxDate.getMonth() < 9
        ? `0${parseInt(maxDate.getMonth()) + 1}`
        : parseInt(maxDate.getMonth()) + 1;
    const day =
      maxDate.getDate() < 10 ? `0${maxDate.getDate()}` : maxDate.getDate();
    const formattedDate = `${maxDate.getFullYear()}-${month}-${day}`;

    SetMaxCalenderDate(formattedDate);
  };

  const customDateModal = () => {
    return (
      <Dialog
        fullWidth
        maxWidth="xs"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Select Custom Date</DialogTitle>
        <DialogContent>
          <Stack gap={2}>
            <Box>
              <Typography mb={1}>From Date</Typography>
              <input
                className="customDateTag"
                type="date"
                defaultValue={startDate}
                onChange={(e) => {
                  setStartDate(formatFromDate(e.target.value));
                  setMaxDateCalender(e.target.value);
                }}
              />
            </Box>
            <Box>
              <Typography mb={1}>To Date</Typography>
              <input
                className="customDateTag"
                type="date"
                defaultValue={endDate}
                max={maxcalenderDate}
                onChange={(e) => setEndDate(formatToDate(e.target.value))}
              />
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ padding: "16px" }}>
          <Button variant="contained" size="small" onClick={handleClose}>
            Save Changes
          </Button>
          <Button variant="contained" size="small" onClick={handleClose}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const handleSelection = (option) => {
    setSelectedMetric(option);
    switch (option) {
      case "currentWeek":
        setStartDate(new Date(getCurrentWeekDates().startDate).getTime());
        setEndDate(new Date(getCurrentWeekDates().endDate).getTime());
        break;
      case "currentMonth":
        setStartDate(getCurrentMonthStartEndDates().startDate);
        setEndDate(getCurrentMonthStartEndDates().endDate);
        break;
      case "previousMonth":
        setStartDate(getPreviousMonthStartEndDates().startDate);
        setEndDate(getPreviousMonthStartEndDates().endDate);
        break;
      case "customMonth":
        setOpen(true);
        break;
    }
  };

  console.log("acivitylogs", isError, data);

  const loginData = JSON.parse(localStorage.getItem("loginDetails"));

  const allClientsData =
    loginData?.role === "admin" ? loginData.clientData : [];

  return (
    <Stack direction="row" gap={0}>
      <NavbarComponent />
      <Stack flexGrow={1} sx={{ padding: "0px 64px 20px" }}>
        <PageTitle title="User Activity" />
        <LeftBox my={2} gap={4}>
          <LeftBox gap={2}>
            <Typography variant="body5">Select Portal</Typography>
            <FormControl sx={{ minWidth: 120 }} size="small">
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={portal}
                label=""
                onChange={(e) => setPortal(e.target.value)}
              >
                {Object.keys(filterData.portal).map((each) => (
                  <MenuItem key={each} value={filterData.portal[each]}>
                    {each}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </LeftBox>
          {allClientsData?.length ? (
            <FormControl size="small" sx={{ minWidth: "150px" }}>
              <Autocomplete
                value={
                  allClientsData.find(
                    (client) => client.clientId === selectedClientId
                  ) || null
                }
                sx={{ width: 250 }}
                options={allClientsData?.length ? allClientsData : []}
                disableCloseOnSelect
                autoHighlight
                isOptionEqualToValue={(option, value) =>
                  option.clientId === value.clientId
                }
                getOptionLabel={(option) => option.org}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {option.org}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Choose Client"
                    size="small"
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "off", // disable autocomplete and autofill
                    }}
                  />
                )}
                onChange={(event, newValue) => {
                  setSelectedClientId(newValue ? newValue.clientId : null);
                }}
              />
            </FormControl>
          ) : (
            // <LeftBox gap={2}>
            //   <Typography variant="body5">Choose Client</Typography>
            //   <FormControl sx={{ minWidth: 120 }} size="small">
            //     <Select
            //       labelId="demo-select-small-label"
            //       id="demo-select-small"
            //       value={selectedClientId}
            //       label=""
            //       onChange={(e) => setSelectedClientId(e.target.value)}
            //     >
            //       {allClientsData.map((each) => (
            //         <MenuItem key={each} value={each.clientId}>
            //           {each.org}
            //         </MenuItem>
            //       ))}
            //     </Select>
            //   </FormControl>
            // </LeftBox>
            ""
          )}
          <Box>
            <FormControl size="small" variant="filled">
              <InputLabel id="demo-select-small-label">Time Period</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={selectedMetric}
                label="Date"
                onChange={(e) => handleSelection(e.target.value)}
                onClick={(e) => {
                  if (e.target.innerText === "Custom Month") {
                    handleSelection("customMonth");
                  }
                }}
              >
                <MenuItem value="currentWeek">Current Week</MenuItem>
                <MenuItem value="currentMonth">Current Month</MenuItem>
                <MenuItem value="previousMonth">Previous Month</MenuItem>
                <MenuItem value="customMonth">Custom Month</MenuItem>
              </Select>
            </FormControl>
            {customDateModal()}
          </Box>
        </LeftBox>
        {isPending ? (
          <LoadingView />
        ) : (
          <LogTable logsData={data?.data?.length ? data.data : []} />
        )}
      </Stack>
    </Stack>
  );
};

export default ActivityLogs;
